module.exports = __webpack_public_path__ + "img/json.90bededa.svg";